import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router';
import styled from 'styled-components';
import { StreamrTvLogoClean } from './Logo';
export function LogoLink({ label = 'StreamrTV', to = '/' }) {
    return (_jsxs(LogoLinkRoot, { to: to, children: [_jsx(LogoContainer, { className: "tv-ui-bright-glass-container", children: _jsx(StreamrTvLogoClean, {}) }), _jsx(LogoLabel, { children: label })] }));
}
const LogoContainer = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--tv-LogoLink-container-width, var(--tv-LogoLink-height, 3rem));
    height: var(
        --tv-LogoLink-container-height,
        var(--tv-LogoLink-height, 3rem)
    );
`;
const LogoLabel = styled.div `
    display: var(--tv-LogoLink-label-display, block);
    font-size: var(--tv-LogoLink-font-size, 1.5rem);
    font-weight: 600;
    color: var(--tv-LogoLink-color, var(--tv-ui-color-3));

    &:empty {
        display: none;
    }
`;
const LogoLinkRoot = styled(Link) `
    --tv-LogoLink-label-display: none;

    width: max-content;
    height: var(--tv-LogoLink-height, 3rem);
    display: flex;
    align-items: center;
    gap: var(--tv-LogoLink-gap, 0.75rem);
    text-decoration: none !important;

    @media (min-width: 32.5rem) {
        --tv-LogoLink-label-display: block;
    }
`;
